import { render, staticRenderFns } from "./Email-Reminder-singale.vue?vue&type=template&id=489e21f9"
import script from "./Email-Reminder-singale.vue?vue&type=script&lang=js"
export * from "./Email-Reminder-singale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports